module.exports = __webpack_public_path__ + "static/media/telegram.69cd77ea.png";